import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../../api/utils/httpRequest"
import type { CategoriesListResponse } from "../../../../../graphql/types"

export const fetchItemsAndCategoriesListData = (
    headers: Record<string, any>,
    locationId: Maybe<string>
): Promise<Maybe<CategoriesListResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query categoriesList($locationId: String) {
                  categoriesList(locationId: $locationId) {
                    data {
                      ...CategoriesData
                      children {
                        ...CategoriesData
                        children {
                          ...CategoriesData
                          children {
                            ...CategoriesData
                            children {
                              ...CategoriesData
                              children {
                                ...CategoriesData
                                children {
                                  ...CategoriesData
                                  children {
                                    ...CategoriesData
                                    children {
                                      ...CategoriesData
                                      children {
                                        ...CategoriesData
                                        children {
                                          ...CategoriesData
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    overrides {
                      locationId
                      data {
                        id
                        isActive
                        price
                      }
                    }
                  }
                }
                
                fragment CategoriesData on CategoriesListItem {
                  id
                  parentId
                  name
                  displayName
                  description
                  type
                  isActive
                  icon
                  color
                  price
                  pricingType
                  unit
                  cardProgramId
                  tileImagePath
                  displayImagePOS
                }
    
            `,
            operationName: "categoriesList",
            variables: {
                locationId: locationId,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.categoriesList) {
            return response.data.categoriesList
        }

        return null
    })
